<template>
    <v-dialog v-model="show" max-width="400px">
        <v-card>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-card-subtitle>
                <span>Выберите библиотеку для сохранения закачки</span>
            </v-card-subtitle>
            <v-card-text justify="center">
                <v-select label="библиотека" :items="catalog" item-text="name" item-value="value"
                          v-model="choiceCatalog.catalog"/>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="#cc7b19" @click="addDownload" small>добавить</v-btn>
                <v-btn color="red" @click="show = !show" small>отменить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "downloadChoice",
    data() {
        return {
            show: false,
            overlay: false,
            torrentId: null,
            catalog: [
                {'name': 'Фильмы', 'value': '/downloads/video'},
                {'name': 'Сериалы', 'value': '/downloads/serials'},
                {'name': 'Музыка', 'value': '/downloads/music'},
            ],
            choiceCatalog: {'catalog': '/downloads/video'},
            fromPage: ''
        }
    },
    methods: {
        open(id, fromPage) {
            this.$http.get('/getName').then((resp) => {
                if (resp.data === 'main-station') {
                    this.catalog.push({'name': 'Временная папка на SAE24', 'value': '/mnt/nfs/music'})
                }
            })
            this.fromPage = fromPage === 'top' ? 'top' : '';
            if (fromPage === 'ruTracker') {
                this.fromPage = 'ruTracker'
            }
            this.torrentId = id
            this.show = true
        },
        addDownload: function () {
            this.overlay = true
            if (this.fromPage !== 'ruTracker') {
                this.$http.post('/downloadFile/' + this.torrentId, this.choiceCatalog).then(() => {
                    this.overlay = false
                    this.$store.dispatch('getUserData')
                    this.show = false
                })
            } else {
                this.$http.post('/downloadFileRu/' + this.torrentId, this.choiceCatalog).then(() => {
                    this.overlay = false
                    this.show = false
                })
            }

        }
    }
}
</script>

<style scoped>

</style>
